import React from "react";

import {
    Row,
    Col,
    Select,
    Input
} from "antd";

const ProductFilters = ({
                            region,
                            setRegion,
                            search,
                            setSearch
                        }) => {

    return (

        <Row gutter={16}>

            <Col span={8}>

                <Input
                    placeholder="Recherche"
                    value={search}
                    onChange={(e) =>
                        setSearch(
                            e.target.value
                        )
                    }
                />

            </Col>

            <Col span={8}>

                <Select
                    style={{ width: "100%" }}
                    placeholder="Région"
                    value={region}
                    onChange={setRegion}
                    allowClear
                    options={[
                        {
                            label: "Maritime",
                            value: "Maritime"
                        },
                        {
                            label: "Plateaux",
                            value: "Plateaux"
                        },
                        {
                            label: "Kara",
                            value: "Kara"
                        }
                    ]}
                />

            </Col>

        </Row>
    );
};

export default ProductFilters;